import axios from 'axios';
import qs from 'qs';
const requetUrl = "http://39.107.84.137:9004";

const requestAxios = axios.create({
	baseURL: requetUrl,
	timeout: 10000,
  withCredentials: false
});
// requestAxios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded";
// requestAxios.defaults.headers.post['Accept'] = "*/*";

//添加请求拦截器
requestAxios.interceptors.request.use(config => {

  if (config.method == "post") {
	  
	  // console.log(config.headers['Content-Type']); 
	  
    if (config.headers['Content-Type'] != 'multipart/form-data') {
		// config.data.company = localStorage.getItem("company");
		// config.data.company = "com2";
		
      config.data = qs.stringify(config.data);
      // console.log(config.data);
    }
  }
  // loadingInstace = Loading.service({
  //   lock: true,
  //   text: 'loading....'
  // });
  return config
});
//添加响应拦截器
requestAxios.interceptors.response.use(response => {
  // loadingInstace.close();
  return response.data;
}, error => {
  // console.log('TCL: error', error);
  const msg = error.Message !== undefined ? error.Message : '';
  // Message({
  //   message: '网络错误' + msg,
  //   type: 'error',
  //   duration: 3 * 1000
  // });
  // loadingInstace.close();
  return Promise.reject(error)
});
export default {
	requetUrl,
	requestAxios
}
